/**
 * LocalStorage utilities for game state persistence
 */

const STORAGE_KEY = 'skylandle_save';

export const getLocalDate = () => {
  // Returns date in YYYY-MM-DD format (user's local timezone)
  return new Date().toLocaleDateString('en-CA');
};

export const saveGameState = (guesses, gameOver) => {
  const state = {
    date: getLocalDate(),
    guesses,
    gameOver
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

export const loadGameState = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (!saved) return null;

  const state = JSON.parse(saved);
  
  // Check if saved state is from today
  if (state.date === getLocalDate()) {
    return state;
  }
  
  // Different day - return null to start fresh
  return null;
};

export const clearGameState = () => {
  localStorage.removeItem(STORAGE_KEY);
};

// Tutorial tracking
const TUTORIAL_SEEN_KEY = 'skylandle_tutorial_seen';

export const hasSeenTutorial = () => {
  return localStorage.getItem(TUTORIAL_SEEN_KEY) === 'true';
};

export const markTutorialAsSeen = () => {
  localStorage.setItem(TUTORIAL_SEEN_KEY, 'true');
};
